// Login action types
export const LOGIN_TYPES = {
  LOGIN: "AUTH_LOGIN",
  LOGOUT: "AUTH_LOGOUT",
  VALIDITY_TOKEN: "AUTH_VALIDITY_TOKEN",
  SET_USER_DATA: "AUTH_SET_USER_DATA",
  REFRESH_AUTH_STATE: "AUTH_REFRESH_STATE",
  LOGIN_ATTEMPT_FAILED: "AUTH_LOGIN_ATTEMPT_FAILED",
  LOGIN_ATTEMPT_RESET: "AUTH_LOGIN_ATTEMPT_RESET",
  LOGIN_ACCOUNT_LOCKED: "AUTH_LOGIN_ACCOUNT_LOCKED",

  // Registration types
  REGISTER_REQUEST: "AUTH_REGISTER_REQUEST",
  REGISTER_SUCCESS: "AUTH_REGISTER_SUCCESS",
  REGISTER_FAILURE: "AUTH_REGISTER_FAILURE",

  // New profile types
  FETCH_PROFILE_REQUEST: "AUTH_FETCH_PROFILE_REQUEST",
  FETCH_PROFILE_SUCCESS: "AUTH_FETCH_PROFILE_SUCCESS",
  FETCH_PROFILE_FAILURE: "AUTH_FETCH_PROFILE_FAILURE",

  UPDATE_PROFILE_REQUEST: "AUTH_UPDATE_PROFILE_REQUEST",
  UPDATE_PROFILE_SUCCESS: "AUTH_UPDATE_PROFILE_SUCCESS",
  UPDATE_PROFILE_FAILURE: "AUTH_UPDATE_PROFILE_FAILURE",

  UPDATE_BIO_REQUEST: "AUTH_UPDATE_BIO_REQUEST",
  UPDATE_BIO_SUCCESS: "AUTH_UPDATE_BIO_SUCCESS",
  UPDATE_BIO_FAILURE: "AUTH_UPDATE_BIO_FAILURE",

  UPDATE_STATE_REQUEST: "AUTH_UPDATE_STATE_REQUEST",
  UPDATE_STATE_SUCCESS: "AUTH_UPDATE_STATE_SUCCESS",
  UPDATE_STATE_FAILURE: "AUTH_UPDATE_STATE_FAILURE",

  VERIFY_ORDER_REQUEST: "AUTH_VERIFY_ORDER_REQUEST",
  VERIFY_ORDER_SUCCESS: "AUTH_VERIFY_ORDER_SUCCESS",
  VERIFY_ORDER_FAILURE: "AUTH_VERIFY_ORDER_FAILURE",

  REPORT_ISSUE_REQUEST: "AUTH_REPORT_ISSUE_REQUEST",
  REPORT_ISSUE_SUCCESS: "AUTH_REPORT_ISSUE_SUCCESS",
  REPORT_ISSUE_FAILURE: "AUTH_REPORT_ISSUE_FAILURE",

  // Allot Member Units action types
  ALLOT_MU_REQUEST: "AUTH_ALLOT_MU_REQUEST",
  ALLOT_MU_SUCCESS: "AUTH_ALLOT_MU_SUCCESS",
  ALLOT_MU_FAILURE: "AUTH_ALLOT_MU_FAILURE",

  // Gift Member Units (user-to-user)
  GIFT_MU_REQUEST: "AUTH_GIFT_MU_REQUEST",
  GIFT_MU_SUCCESS: "AUTH_GIFT_MU_SUCCESS",
  GIFT_MU_FAILURE: "AUTH_GIFT_MU_FAILURE",
  
  DELETE_ACCOUNT_REQUEST: "AUTH_DELETE_ACCOUNT_REQUEST",
  DELETE_ACCOUNT_SUCCESS: "AUTH_DELETE_ACCOUNT_SUCCESS",
  DELETE_ACCOUNT_FAILURE: "AUTH_DELETE_ACCOUNT_FAILURE",

  // Message actions
  FETCH_MESSAGES_REQUEST: "FETCH_MESSAGES_REQUEST",
  FETCH_MESSAGES_SUCCESS: "FETCH_MESSAGES_SUCCESS",
  FETCH_MESSAGES_FAILURE: "FETCH_MESSAGES_FAILURE",

  SEND_MESSAGE_REQUEST: "SEND_MESSAGE_REQUEST",
  SEND_MESSAGE_SUCCESS: "SEND_MESSAGE_SUCCESS",
  SEND_MESSAGE_FAILURE: "SEND_MESSAGE_FAILURE",
  
  // Friends list actions
  FETCH_FRIENDS_LIST_REQUEST: "FETCH_FRIENDS_LIST_REQUEST",
  FETCH_FRIENDS_LIST_SUCCESS: "FETCH_FRIENDS_LIST_SUCCESS",
  FETCH_FRIENDS_LIST_FAILURE: "FETCH_FRIENDS_LIST_FAILURE",
  
  ADD_FRIEND_REQUEST: "ADD_FRIEND_REQUEST",
  ADD_FRIEND_SUCCESS: "ADD_FRIEND_SUCCESS",
  ADD_FRIEND_FAILURE: "ADD_FRIEND_FAILURE",
  
  REMOVE_FRIEND_REQUEST: "REMOVE_FRIEND_REQUEST",
  REMOVE_FRIEND_SUCCESS: "REMOVE_FRIEND_SUCCESS",
  REMOVE_FRIEND_FAILURE: "REMOVE_FRIEND_FAILURE",

  MARK_MESSAGE_READ_REQUEST: "MARK_MESSAGE_READ_REQUEST",
  MARK_MESSAGE_READ_SUCCESS: "MARK_MESSAGE_READ_SUCCESS",
  MARK_MESSAGE_READ_FAILURE: "MARK_MESSAGE_READ_FAILURE",

  // Sent Messages actions
  FETCH_SENT_MESSAGES_REQUEST: "FETCH_SENT_MESSAGES_REQUEST",
  FETCH_SENT_MESSAGES_SUCCESS: "FETCH_SENT_MESSAGES_SUCCESS",
  FETCH_SENT_MESSAGES_FAILURE: "FETCH_SENT_MESSAGES_FAILURE",
  
  // Message deletion actions
  DELETE_MESSAGE_REQUEST: "DELETE_MESSAGE_REQUEST",
  DELETE_MESSAGE_SUCCESS: "DELETE_MESSAGE_SUCCESS",
  DELETE_MESSAGE_FAILURE: "DELETE_MESSAGE_FAILURE",
  
  // Avatar actions
  FETCH_AVATARS_REQUEST: "AUTH_FETCH_AVATARS_REQUEST",
  FETCH_AVATARS_SUCCESS: "AUTH_FETCH_AVATARS_SUCCESS",
  FETCH_AVATARS_FAILURE: "AUTH_FETCH_AVATARS_FAILURE",

  UPDATE_AVATAR_REQUEST: "AUTH_UPDATE_AVATAR_REQUEST",
  UPDATE_AVATAR_SUCCESS: "AUTH_UPDATE_AVATAR_SUCCESS",
  UPDATE_AVATAR_FAILURE: "AUTH_UPDATE_AVATAR_FAILURE",

  // Members list actions (all community members, for Members tab)
  FETCH_MEMBERS_REQUEST: "FETCH_MEMBERS_REQUEST",
  FETCH_MEMBERS_SUCCESS: "FETCH_MEMBERS_SUCCESS",
  FETCH_MEMBERS_FAILURE: "FETCH_MEMBERS_FAILURE",

  // Phase 1C: Admin elevation (sidecar model)
  ADMIN_ELEVATE_SUCCESS: "AUTH_ADMIN_ELEVATE_SUCCESS",
  ADMIN_SWITCH_TO_USER: "AUTH_ADMIN_SWITCH_TO_USER"
};

